import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Dialog } from "@surfaces/Dialog";
import { PlainAutocomplete } from "../../../inputs/autocomplete/PlainAutocomplete";
import type { ISelectedObjective } from "../logics/types";
import { useModalObjectives } from "./logics";

export interface IModalAddObjectivesProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ISelectedObjective[]) => Promise<void> | void;
  loading: boolean;
}

export const ModalAddObjectives = ({ open, onClose, onSubmit, loading }: IModalAddObjectivesProps) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("tablet"));
  const { options, selectedOptions, setSelectedOptions, handleClose, handleSubmit } = useModalObjectives(
    onClose,
    onSubmit
  );

  return (
    <Dialog open={open} fullScreen={isTablet} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h4">Ajouter un ou plusieurs objectifs</Typography>
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ height: 700, overflow: "auto" }}>
        <PlainAutocomplete<ISelectedObjective>
          value={selectedOptions}
          options={options}
          onChange={setSelectedOptions}
          placeholder="Chercher une thématique ou un objectif"
          groupBy={(opt) => opt.challenge.name}
          getOptionLabel={(opt) => opt.objective.name}
          getOptionKey={(opt) => opt.objective._id}
          isOptionEqualToValue={(a, b) => a.objective._id === b.objective._id}
          groupLabelVariant="h4"
          groupLabelColor="primary"
          showSelectAll={false}
          showGroupCheckboxes={false}
          showAllOptions={true}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleClose}>
          Annuler
        </Button>
        <Button
          loading={loading}
          variant="contained"
          color="primary"
          onClick={() => handleSubmit()}
          disabled={selectedOptions.length === 0}
        >
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export * from "./logics.js";
export * from "./utils.js";
